













import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
// @ts-ignore
import { mdbScrollbar } from 'mdbvue'

@Component({
  components: {
    mdbScrollbar
  }
})
export default class App extends Vue {}
